export enum Permissions {
  MarginReportsModify = "margin_reports.modify",
  MarginProcessingUiNavView = "margin_processing.UI.navigation.view",
  MarginProcessingSearchFull = "margin_processing.search.full",
  AccountRead = "account.read",
}
